import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'cash-sales.cover-everything',
    country: ['CO', 'PR', 'DO', 'GT', 'SV', 'NI', 'PA', 'CR']
  },
  {
    feature: 'cash-sales.order-time-out',
    options: {
      seconds: 900
    }
  }
] as IAppConfiguration[];
